import React, { useState } from "react";
import { Sun, Moon } from "lucide-react";

const KEY = "ahjin-light";

export const isLight = () => localStorage.getItem(KEY) === "1";

export const applyLight = (on) => {
  document.documentElement.classList.toggle("theme-light", on);
};

export const ThemeToggle = ({ className = "" }) => {
  const [light, setLight] = useState(isLight());
  const toggle = () => {
    const next = !light;
    setLight(next);
    localStorage.setItem(KEY, next ? "1" : "0");
    applyLight(next);
  };
  return (
    <button
      type="button"
      onClick={toggle}
      data-testid="theme-toggle"
      aria-label={light ? "Switch to dark theme" : "Switch to light theme"}
      className={`inline-flex items-center justify-center rounded-full border border-purple-500/40 bg-purple-600/10 hover:border-[#E5C56F]/60 hover:text-[#FFE9A8] w-8 h-8 text-purple-200 transition-colors duration-300 ${className}`}
    >
      {light ? <Moon size={13} strokeWidth={1.8} /> : <Sun size={13} strokeWidth={1.8} />}
    </button>
  );
};

export default ThemeToggle;
